import { render, staticRenderFns } from "./SummarySkeleton.vue?vue&type=template&id=575c68fb&scoped=true&"
import script from "./SummarySkeleton.vue?vue&type=script&lang=js&"
export * from "./SummarySkeleton.vue?vue&type=script&lang=js&"
import style0 from "./SummarySkeleton.vue?vue&type=style&index=0&id=575c68fb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "575c68fb",
  null
  
)

export default component.exports